import validationReglesAchat from '@/services/catalogue/validation/validationReglesAchat';
import validationSecteur from '@/services/commun/secteur/validationSecteur';

export default function validation(response, produit) {
  const messages = [];

  if (!response.data.error.validationErrors) {
    return messages;
  }
  validationSecteur(response, messages);
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('The Categorie field is required') !== -1) {
      messages.push({
        message: 'catalogue.validation.categoryRequired',
      });
    }
    if (message.indexOf('PACK_PRODUCT_WITH_BILLBOARD') !== -1) {
      messages.push({
        message: 'catalogue.validation.packProductWithBillboard',
      });
    }
    if (message.indexOf('UNABLE_TO_UPDATE_SOLD_INSERT') !== -1) {
      if (!messages.find(msg => msg.message === 'catalogue.validation.encartSold')) {
        messages.push({
          message: 'catalogue.validation.encartSold',
        });
      }
    }
    if (message.indexOf('PACK_PRODUCT_DATE_START_GREATER_THAN_END_DATE') !== -1) {
      messages.push({
        message: 'catalogue.validation.startDateGreaterThanEndDate',
      });
    }
    if (message.indexOf('PACK_PRODUCT_AFFECATION_DATE_START_GREATER_THAN_END_DATE') !== -1) {
      messages.push({
        message: 'catalogue.validation.affectationStartDateGreaterThanEndDate',
      });
    }
    if (message.indexOf('ONLY_ONE_OBJECTIVE_PER_YEAR_AND_COMMERCIAL') !== -1) {
      messages.push({
        message: 'catalogue.validation.onlyOneObjectifByCommercial',
      });
    }
    if (message.indexOf('DATES_OVERLAP_FOR_COMMERCIAL') !== -1) {
      const commercial = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'catalogue.validation.dateCommercialOverlap',
        parametres: {
          commercial: commercial,
        },
      });
    }
    if (message.indexOf('PRODUIT_DIVERS_CANT_BE_HONORARY_AND_TLPE') !== -1) {
      messages.push({
        message: 'catalogue.validation.produitDiversTlpeEtHonoraire',
      });
    }
    if (message.indexOf('PRODUCT_LIBELLE_EMPTY') !== -1) {
      messages.push({
        message: 'catalogue.validation.productLibelleEmpty',
      });
    }
    if (message.indexOf('AFFECTATION_RESEAU_FACE_DATE_OVERLAPING') !== -1) {
      messages.push({
        message: 'catalogue.validation.affectationReseauFaceDateOverlaping',
      });
    }
    if (message.indexOf('AFFECTATION_RESEAU_DATE_OVERLAPING') !== -1) {
      const elements = message.split('|')[0].split('@');
      let periodes = elements[2];
      periodes = periodes.split(',').join('\n');
      let champ;
      if (produit && produit.produitReseau) {
        champ = produit.produitReseau.affectationsReseauFace.find(el => el.produitId === elements[1]
          || el.produit.id === elements[1]);
      } else if (produit && produit.produitReseauNumerique) {
        champ = produit.produitReseau.affectationsReseauEcran.find(el => el.produitId
          === elements[1] || el.produit.id === elements[1]);
      }
      messages.push({
        message: 'catalogue.validation.affectationReseauFaceReseauDateOverlaping',
        parametres: {
          produit: champ.produit.reference,
          periodes: periodes,
        },
      });
    }
    if (message.indexOf('LIAISON_TARIF_DATE_OVERLAPING') !== -1) {
      const champ = message.split('LIAISON_TARIF_DATE_OVERLAPING_')[1].split('_')[1].split('|')[0];
      messages.push({
        message: 'catalogue.validation.liaisonTarifDateOverlaping',
        parametres: {
          produit: champ,
        },
      });
    }
    if (message.indexOf('LIAISON_TARIF_SENS_DIFF_PRODUCT') !== -1) {
      const libelleLiaison = message.split('LIAISON_TARIF_SENS_DIFF_PRODUCT')[1].split('@')[2].split('|')[0];
      messages.push({
        message: 'catalogue.validation.liaisonTarifSens',
        parametres: {
          libelleLiaison: libelleLiaison,
        },
      });
    }
    if (error.members && error.members[0] === 'dateDebut') {
      messages.push({
        message: 'catalogue.validation.dateDebut',
      });
    }
    if (message.indexOf('LIAISON_TARIF_START_DATE_GREATER_THAN_END_DATE') !== -1) {
      const libelleLiaison = message.split('LIAISON_TARIF_START_DATE_GREATER_THAN_END_DATE')[1].split('@')[1].split('|')[0];
      messages.push({
        message: 'catalogue.validation.liaisonTarifDateFinBeforeDateDebut',
        parametres: {
          libelleLiaison: libelleLiaison,
        },
      });
    } else if (message.indexOf('START_DATE_GREATER_THAN_END_DATE') !== -1) {
      messages.push({
        message: 'catalogue.validation.dateFinBeforeDateDebut',
      });
    }
    if (message.indexOf('FORBIDDEN_TO_UPDATE_CREATE_DIV_LOC_WITH_HOLDING') !== -1) {
      messages.push({
        message: 'catalogue.validation.updateProduitWithHolding',
      });
    }
    if (message.indexOf('FORBIDDEN_TO_DELETE_IF_SALE_EXISTS') !== -1) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'catalogue.validation.encart.noDeleteEncart',
        parametres: {
          reference: elements[1],
        },
      });
    }
    if (message.indexOf('RESEAU_MAIRIE_FACE_COMMERCIALISABLE_NOT_ALLOWED') !== -1) {
      messages.push({
        message: 'catalogue.validation.reseauMairieFaceCommercialisableNotAllowed',
      });
    }
    if (message.indexOf('RESEAU_USED_IN_SALE') !== -1) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'suppressionProduitReseau.validation.noDeleteReseauUsedInSale',
        parametres: {
          recurrence: elements[1],
        },
      });
    }
    if (message.indexOf('RESEAU_USED_IN_TFS') !== -1) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'suppressionProduitReseau.validation.noDeleteReseauUsedInTFS',
        parametres: {
          recurrence: elements[1],
        },
      });
    }
    if (message.indexOf('RESEAU_USED_IN_LOGISTIC_REQUEST') !== -1) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'suppressionProduitReseau.validation.noDeleteReseauUsedInLogisticRequest',
        parametres: {
          recurrence: elements[1],
        },
      });
    }
    if (message.indexOf('RESEAU_MAIRIE_ONLY_DIVERS_IN_LIAISON') !== -1) {
      messages.push({
        message: 'catalogue.validation.reseauMairieOnlyDiversInLiaison',
      });
    }
    if (message.indexOf('PRODUIT_REGLE_FACTURATION_REQUIRED') === 0) {
      messages.push({
        message: 'catalogue.validation.regleFacturationRequired',
      });
    }
    if (message.indexOf('PRODUIT_FACE_FORBIDDEN_TO_ARCHIVE_PRODUIT_FACE_LINKED_TO_PATRIMONY') === 0) {
      messages.push({
        message: 'catalogue.validation.impossibleToArchiveProduitFaceLiePatrimoine',
      });
    }
    if (message.indexOf('REFERENCE_TOO_BIG') === 0) {
      const element = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'catalogue.validation.referenceTooBig',
        parametres: {
          reference: element,
        },
      });
    }
    if (message.indexOf('PACK_PRODUCT_FACE_MUST_BE_FROM_SAME_COMPANY_AS_NETWORK_PRODUCT') === 0) {
      const element = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'catalogue.validation.faceMustBeFromSameCompanyAsTheNetworkProduct',
        parametres: {
          libelle: element,
        },
      });
    }
    validationReglesAchat(message, messages);
  });
  return messages;
}
